import styled from '@emotion/styled'

import { BayMachineOn } from '../../../../utils'

import { BayName } from './BayName'


interface BayItemOnProps extends BayMachineOn {
  onClick: () => void
  size?: 'lg' | 'md' | 'sm'
}

const StyledBayItemOn = styled.div<{ isPrivate?: 0 | 1 }>`
    border: 2px solid
        ${({theme, isPrivate}) =>
    isPrivate ? theme.bay.private : theme.pallete.blue[400]};
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    padding: 10px 16px;
    background-color: ${({theme: {pallete}}) => pallete.gray[700]};

    ${({theme}) => theme.font.heading2}


    &.sm {
      padding: 8px 12px;
    }

    &:active {
        transform: scale(0.98);
    }
`

export default function BayItemOn(info: BayItemOnProps) {
  return (
    <>
      <StyledBayItemOn
        isPrivate={info.private}
        onClick={info.onClick}
        className={info.size}
        data-testid="bay-on"
      >
        <BayName className={info.size}>{info.name}</BayName>
      </StyledBayItemOn>
    </>
  )
}
